export default function WarningIcon({className = ''}: {className?: string}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M10.29 3.86a1.5 1.5 0 0 1 2.42 0l8.48 13.2A1.5 1.5 0 0 1 19.98 19H4.02a1.5 1.5 0 0 1-1.21-1.94l7.48-13.2ZM12 9a.75.75 0 0 0-.75.75v3.75a.75.75 0 0 0 1.5 0V9.75A.75.75 0 0 0 12 9Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
